<template>
  <div class="DataTableFilteredOnApiLoginAuditComponent  DataTables">
    
    <p>{{lang.infotext_1}}:</p>
    <div :id="id">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>
    <!-- <ContextMenuComponent v-if="!isPlugin" :menu="menu" :id="name"></ContextMenuComponent> -->
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '@/Tools/Tools';
import dt from 'datatables.net-bs4';
import LibraryTypes from '@/constants/LibraryTypes'
import PartPropertiesType from '@/constants/PartPropertiesType'



require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"
//import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'
export default {
  name: 'DataTableFilteredOnApiLoginAuditComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    //ContextMenuComponent

  },
  data () {
      return {
        name: "DataTableFilteredOnApiLoginAuditComponent",
        id: "tableplace_" + this._uid,
        columns: [],
        colsAssign: [],
        activeActionIds: [],
        contextMenu: {},
        //list of items in the context menu:
        menu: [
          //{id: "Details", text: this.lang.contextmenu_text_Details},
          
        ],
                
        lengthMenu: 20,
      }
  },
  computed: {
    ...mapGetters({
      appConf: 'appConf',
      isPlugin: "isPlugin"

    }),
    categoryId(){
      if (this.$store.getters.selectedTreeLibraryItemObject == undefined){
        return 1;
      }else{
        return this.$store.getters.selectedTreeLibraryItemObject.categoryId;
      }
    },
    selectedTreeLibraryItemObject(){

      return this.$store.getters.selectedTreeLibraryItemObject
    },
    activeActions(){

      return this.$store.getters.rm_activeActions
    },
    isData(){

      return false
    },
    /*server(){

      return this.$store.getters.server;
    },*/
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    this.activeActionIds = [];
    
    for (let i = 0, lei = this.activeActions.length; i < lei; i++){
      
      const obj = {
        actionId: this.activeActions[i].actionId
      }
      this.activeActionIds.push(obj);
    }
    
  },
  watch: {
    categoryId: function(){
      
      this.getProperties();
    },
    activeActions: {
      handler: function(){

        this.activeActionIds = [];
        for (let i = 0, lei = this.activeActions.length; i < lei; i++){
          
          const obj = {
            actionId: this.activeActions[i].actionId
          }
          this.activeActionIds.push(obj);
        }
        

       
        this.getProperties();
      },
      deep: true
    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getProperties();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    

  },
  
  mounted: function () {
    
    this.getProperties();


  },
  methods: {
    getProperties() {

      
      let reloadObj = {
        status: true,
        name: "Refresh"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      
      let vue = this;

      

      vue.buildColumns();

    },
    

    buildColumns(properties) {
      
      this.columns = [
        {
          name: this.lang.table_header_FirstName,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        {
          name: this.lang.table_header_LastName,
          alignInColumn: "left",
          propertyId: "",
          type: "image"
        },
        {
          name: this.lang.table_header_Username,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        {
          name: this.lang.table_header_Role,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        {
          name: this.lang.table_header_Success,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        {
          name: this.lang.table_header_LoginDate,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        {
          name: this.lang.table_header_LogoutDate,
          alignInColumn: "left",
          propertyId: "",
          type: "text"
        },
        
        
        
      ];
 
    this.colsAssign = [
      
      { "data": "col___firstName" },
      { "data": "col___lastName" },
      { "data": "col___username" },
      { "data": "col___role" },
      { "data": "col___success" },
      { "data": "col___loginDate" },
      { "data": "col___logoutDate" },
      
  
    ]
      
      

      this.buildTable();
    },


    buildTable(){
      
      
      var tableplace = document.getElementById("tableplace_"+this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      var tr2 = document.createElement("tr");
      tr2.setAttribute("class", "cellFooter");
      var tfoot = document.createElement("tfoot");
      tfoot.appendChild(tr2);
      place.appendChild(tfoot);



      var columnDefs = [];


      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++){

        let el = {
          targets: i,
          className: '_dt-body-'+ _vue.columns[i].alignInColumn,
          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            
            if (data.value.display != undefined) {
              data.value.display = $.fn.dataTable.render.text().display(data.value.display);
            }

            if (meta.col == 0){
              
              return data.value.display;
              

            }

            let toDisplay = "";
            if (data == undefined){
              
              data = {
                value: {
                  display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                }
              }
            }
            
            
            if (data.value != null) {
              if (data.value.display == null) {
                toDisplay = "";
              } else {
                toDisplay = data.value.display;
              }
                
            
            }
            if (meta.col == 4) {
              

              if (data.value.display == "true") {

                toDisplay = "<b-badge class='badge badge-success'>true</b-badge>";
                
              } else {
                toDisplay = "<b-badge class='badge badge-danger'>false</b-badge>";
              }
                           
                            
            }
            
            if (meta.col == 5) {
                         
              toDisplay = Tools.longDateToShort(data.value.display);
              
            }
            if (meta.col == 6) {
                         
              toDisplay = Tools.longDateToShort(data.value.display);
              
            }
            
            
             
            return  toDisplay;
            

  
          }
        }



      columnDefs.push(el);




        var th1 = document.createElement("th");
        
        tr1.appendChild(th1);
        
        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        th1.appendChild(br);
        th1.appendChild(tx);

      }

        let vue = this;


      var option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[20, -1], [20, "All"]];
      option.order = [[ 5, "desc" ]];
      option.select = false;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;
      
      option.dom = '<fBlr<t>ip>';
      
      
      option.processing= true;
      option.serverSide= true;
      // option.search = {
      //   regex: true
      // }
      option.initComplete = function (settings, json) {
        

        this.api().columns().every( function () {
          // var column = this;

          // if (vue.columns[column[0][0]].type != "image"){
          //   var select = $('<select><option value=""></option></select>')
          //     .appendTo( $(column.footer()).empty() )
          //     .on( 'change', function () {

          //         var val = $.fn.dataTable.util.escapeRegex(
          //             $(this).val()
          //         );

          //         column
          //             .search( val ? val : '', true, false )
          //             .draw();
          //     } );
          //   let arr = [];
          //   column.data().unique().sort().each( function ( d, j ) {
          //     if (d == null){
          //       return
          //     }
              
          //     if (d.value.display != null){

          //       //if (!arr.includes(d.value.display)){
          //         arr.push(d.value.display);
          //         select.append( '<option value="' + d.value.display + '">' + d.value.display + '</option>' );
          //       //}

          //     }


          //   });
          // }

        });


        
      }
      option.fnDrawCallback = function( oSettings ) {
        
        //vue.buildContextMenu();
      }
      option.buttons = [
        {
          extend: 'copy',
          className: 'btn-' + vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + vue.variant,
          messageTop: function () {
            return vue.lang.export_label_top;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',
          
          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )
                  

              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend:'excel',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
            customize: function ( xlsx ){

            var sheet = xlsx.xl.worksheets['Parts.xml'];


        }},
        {
          extend: 'pdfHtml5',
          messageTop: function () {
                  return vue.lang.export_label_top;
          },
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'portraid',
          pageSize: 'A4',
          download: 'open',
          
          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]		
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {
            

            doc.pageMargins = [10,10,10,10];
            
            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();
            
            let numberOfHeaders = columnDefs.length;
            
            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){
              
              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }
            
          },
          
        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + vue.variant,
            action: function ( e, dt, button, config ) {
                var data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    'LoginAudit.json'
                );
            }
        },
        {
          text: 'Reload',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {

            vue.mainTable.ajax.reload();
          }

        },
        {
          extend: 'colvis',
          className: 'btn-' + vue.variant,
          
        },
      ];

      option.ajax = {
        url: /*this.server + */"/api/v3/partmanagement/auth/GetLoginAudit",
        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // console.log(xhr)
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON.message == "Authorization failure."){
            
            vue.$store.dispatch("logout");
          }
          
        },
        data: function ( json ) {
          

          let categoryId = 1;

          if (vue.categoryId != undefined){

            categoryId = vue.categoryId;
          }

          json.categoryId = categoryId;

          let actions = vue.activeActionIds;

          json.actions = actions;

          

          for (let i = 0, lei = json.columns.length; i < lei; i++){
            json.columns[i].col = i;
          }


          
          return JSON.stringify(json);
        },
        dataFilter: function(data){
          
          
          y = 0;
          
            var json = JSON.parse(data);
          
                               

            let newJson = {
              draw: json.data.draw,
              recordsFiltered: json.data.recordsFiltered,
              recordsTotal: json.data.recordsTotal,
              data: []
            }
            let rows = [];
            vue.lengthMenu = json.data.data.length;
            for (let i = 0, lei = json.data.data.length; i < lei; i++ ) {

              let row = {};
              let firstNameObj = {
                                                
                value: {
                  display: json.data.data[i].firstName,
                  filter: json.data.data[i].firstName,
                  sort: json.data.data[i].firstName,                  
                }
              };

              let firstName = "col___firstName";
              row[firstName] = firstNameObj;

              let lastNameObj = {
                                                
                value: {
                  display: json.data.data[i].lastName,
                  filter: json.data.data[i].lastName,
                  sort: json.data.data[i].lastName,                  
                }
              };

              let lastName = "col___lastName";
              row[lastName] = lastNameObj;

              let usernameObj = {
                                                
                value: {
                  display: json.data.data[i].username,
                  filter: json.data.data[i].username,
                  sort: json.data.data[i].username,                  
                }
              };

              let username = "col___username";
              row[username] = usernameObj;

              let roleObj = {
                                                
                value: {
                  display: json.data.data[i].role,
                  filter: json.data.data[i].role,
                  sort: json.data.data[i].role,                  
                }
              };

              let role = "col___role";
              row[role] = roleObj;

              let successObj = {
                                                
                value: {
                  display: json.data.data[i].success,
                  filter: json.data.data[i].success,
                  sort: json.data.data[i].success,                  
                }
              };

              let success = "col___success";
              row[success] = successObj;

              let loginDateObj = {
                                                
                value: {
                  display: json.data.data[i].loginDate,
                  filter: json.data.data[i].loginDate,
                  sort: json.data.data[i].loginDate,                  
                }
              };

              let loginDate = "col___loginDate";
              row[loginDate] = loginDateObj;

              let logoutDateObj = {
                                                
                value: {
                  display: json.data.data[i].logoutDate,
                  filter: json.data.data[i].logoutDate,
                  sort: json.data.data[i].logoutDate,                  
                }
              };

              let logoutDate = "col___logoutDate";
              row[logoutDate] = logoutDateObj;

              

              

              rows.push(row);
            }


            newJson.data = rows;

            

            return JSON.stringify(newJson);
          },

        }



          if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
              this.mainTable.destroy();

          }

          this.mainTable = $('#place'+this._uid).DataTable(option);
          
          //this.mainTable.column( 0 ).visible( false );

          let el = document.getElementsByClassName("dataTables_processing")[0]
          
         
          el.classList.add("processing-top");
          
          

          //search input change view
          var searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }


          searchplace.firstChild.setAttribute("placeholder", "Enter search words")
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
          searchplace.firstChild.addEventListener("input", function(evt){

            _vue.$store.dispatch("setFilteredData", evt.target.value);

          })
          let lengthplace = document.getElementById("place"+this._uid+"_length");
          
          if (lengthplace.firstChild.firstChild != null){
            lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
          }
          
          var stepWait = 0;
          var waitInterval;
          $(".dataTables_filter input")
            .unbind()
            .bind('input', function (e) {
              var item = $(this);
              stepWait = 0;

              if (!waitInterval) {
                waitInterval = setInterval(function () {

                  if (stepWait >= 3) {
                    clearInterval(waitInterval);
                    waitInterval = '';
                    let searchString = $(item).val();
                    _vue.mainTable.search(searchString).draw();
                    stepWait = 0;
                  }
                  stepWait++;
                }, 150);
              }

            });

          //let _mainTable = this.mainTable;
          // this.mainTable
          // .on( 'select', function ( e, dt, type, indexes ) {
              
              
              

          // })
          // .on( 'deselect', function ( e, dt, type, indexes ) {

            
          // });
          
          // $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
            
          // } );

      
      },
      


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .DataTableFilteredOnApiLoginAuditComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space:nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 80px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 50px;
    }
    

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 350px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image-category{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      
    }
    .badge{
      margin-right: 1px;
      
      margin-bottom: 2px;
    }
    .badges{
      margin-top: 3px;
      margin-bottom: 2px;
    }
    .image-svg{
      max-width: 30px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-right: 3px;
      margin-bottom: 3px;
      background-color: white;
      padding: 2px;
    }
    .progress{
      margin: 5px;
      margin-top: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DataTableFilteredOnApiLoginAuditComponent.vue